export const CLINIC = {
  name: "Amar Sagoo Nursing Inc",
  tagline: "Addiction Medicine, Delivered With Dignity",
  phone: "747-499-0920",
  email: "care@amarsagoonursing.com",
  hours: [
    { day: "Mon – Thu", time: "8:00 AM – 6:00 PM" },
    { day: "Friday", time: "8:00 AM – 4:00 PM" },
    { day: "Sat – Sun", time: "By appointment" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1587304798516-e17f7191a3a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxjYWxtJTIwYWJzdHJhY3QlMjBuYXR1cmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDkyMDA0MHww&ixlib=rb-4.1.0&q=85",
  manifesto1: "https://images.unsplash.com/photo-1624727828489-a1e03b79bba8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxjYXJpbmclMjBlbXBhdGhldGljJTIwaGVhbHRoY2FyZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODQ5MjAwNDB8MA&ixlib=rb-4.1.0&q=85",
  manifesto2: "https://images.unsplash.com/photo-1782397132123-0166b524d6bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3YXJtJTIwbWVkaWNhbCUyMGNsaW5pYyUyMGludGVyaW9yfGVufDB8fHx8MTc4NDkyMDA0MHww&ixlib=rb-4.1.0&q=85",
  team1: "https://images.pexels.com/photos/33726865/pexels-photo-33726865.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  texture: "https://images.unsplash.com/photo-1590078745549-95edebeb0b4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxjYWxtJTIwYWJzdHJhY3QlMjBuYXR1cmUlMjB0ZXh0dXJlfGVufDB8fHx8MTc4NDkyMDA0MHww&ixlib=rb-4.1.0&q=85",
};

export const CHAPTERS = [
  {
    no: "01",
    title: "The Approach",
    body: "We begin with listening. Every recovery plan is built around the person, not the diagnosis — meeting each patient with respect, confidentiality, and zero judgement.",
    img: IMAGES.manifesto1,
  },
  {
    no: "02",
    title: "The Treatment",
    body: "Evidence-based, medically supervised care. From medication-assisted treatment to structured detox support, our nursing team keeps you safe through every stage.",
    img: IMAGES.manifesto2,
  },
  {
    no: "03",
    title: "The Aftercare",
    body: "Recovery does not end at discharge. We stay present with relapse-prevention planning, counseling connections, and community support that lasts.",
    img: IMAGES.hero,
  },
];

export const SERVICES = [
  { title: "Medication-Assisted Treatment", desc: "Suboxone, methadone & naltrexone programs managed by experienced nursing staff.", span: "md:col-span-7" },
  { title: "Medically Supervised Detox", desc: "Safe, monitored withdrawal support with 24/7 clinical oversight.", span: "md:col-span-5" },
  { title: "Counseling & Therapy", desc: "One-on-one and group sessions addressing the roots of dependency.", span: "md:col-span-5" },
  { title: "Relapse Prevention & Aftercare", desc: "Long-term planning, check-ins and community reintegration support.", span: "md:col-span-7" },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years in addiction medicine" },
  { value: 2400, suffix: "+", label: "Patients supported" },
  { value: 92, suffix: "%", label: "Treatment retention rate" },
  { value: 24, suffix: "/7", label: "Clinical support access" },
];

export const TEAM = [
  { name: "Amar Sagoo, FNP", role: "Founder & Family Nurse Practitioner", img: IMAGES.team1 },
  { name: "Dr. Lena Ford, MD", role: "Consulting Addiction Physician", img: IMAGES.manifesto1 },
  { name: "Marcus Reid, RPN", role: "Detox & MAT Coordinator", img: IMAGES.manifesto2 },
];

export const FAQS = [
  { q: "Is my treatment confidential?", a: "Absolutely. All care is fully confidential and protected under privacy legislation. Your recovery is yours alone." },
  { q: "Do I need a referral to start?", a: "No referral is required. You can reach out directly through our contact form and our intake team will guide you from there." },
  { q: "What is medication-assisted treatment (MAT)?", a: "MAT combines FDA/Health-Canada approved medications with counseling to treat substance use disorders, reducing cravings and withdrawal safely." },
  { q: "How long does a program last?", a: "Every plan is individualized. Some patients stabilize in weeks, others benefit from months of ongoing support — we build the timeline around you." },
  { q: "Do you support families?", a: "Yes. Addiction affects the whole family. We offer guidance and resources for loved ones supporting someone in recovery." },
];


export const AESTHETICS = [
  { no: "A", title: "Aesthetics", desc: "Personalized cosmetic treatments to refresh and enhance your natural features, delivered with a clinical eye and a gentle touch." },
  { no: "B", title: "Anti-Aging", desc: "Rejuvenating therapies that soften fine lines, restore volume and support healthy, radiant skin as you age gracefully." },
  { no: "C", title: "Weight Loss", desc: "Medically guided, sustainable weight management programs tailored to your body, goals and overall wellness." },
  { no: "D", title: "Microneedling", desc: "Collagen-induction therapy that improves texture, tone and scarring for smoother, firmer, more even skin." },
];
